import React from 'react';
import PropTypes from 'prop-types';
import { withPolyglot } from '../../../i18n';
import AuthLayout, { HeaderIcon } from '../AuthLayout';
import { Box, Alert, Typography } from '@mui/material';

export function PostResetTriggerPage(props) {
  const { polyglot } = props;
  return (
    <AuthLayout>
      <Box margin={2}>
        <Alert
          icon={<HeaderIcon />}
          severity="info"
          sx={{ flexDirection: 'column' }}
        >
          <Typography variant="subtitle2" className="lead">
            {polyglot.t('reset_password.post_reset_message')}
          </Typography>
        </Alert>
      </Box>
    </AuthLayout>
  );
}

PostResetTriggerPage.propTypes = {
  polyglot: PropTypes.shape({
    t: PropTypes.func.isRequired,
  }).isRequired,
};

export default withPolyglot(PostResetTriggerPage);
